import instance from '@/services/repository';

const resource = '/articles';

export default {
    /*get() {
        return instance.get(`${resource}`);
    },*/
    create(payload: IArticleCreateCommand) {
        return instance.post<IArticle>(`${resource}`, payload);
    },
    copy(payload: IArticleCopyCommand) {
        return instance.post<IArticle>(`${resource}/copy`, payload);
    },
    /*update(payload: any) {
        payload.defaultPrice = null;
        return instance.put(`${resource}/${payload.id}`, payload);
    },*/
    updateBasics(payload: IArticleUpdateBasicsCommand) {
        return instance.put<IArticle>(`${resource}/${payload.id}/Basics`, payload);
    },
    updateLabourcost(payload: IArticleLabourCostCommand) {
        return instance.put<IArticle>(`${resource}/${payload.id}/Labourcosts`, payload);
    },
    updateBillOfMaterial(payload: IArticleBillOfMaterialsCommand) {
        return instance.put<IArticle>(`${resource}/${payload.id}/BillOfMaterials`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
    createVariant(id: string, name: string) {
        return instance.post<IArticle>(`${resource}/${id}/variants/${name}`);
    },
    updateVariant(id: string, name: string, variant: IArticleVariant) {
        return instance.put<IArticle>(`${resource}/${id}/variants/${name}`, variant);
    },
    deleteVariant(id: string, name: string) {
        return instance.delete<IArticle>(`${resource}/${id}/variants/${name}`);
    },
};
